<template>
  <div>
    <g-master name="evaluaciones"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              ref="master"
              :parentData="parenData"
              modalWidth="90%">
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Etiqueta">
              <a-input
                v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item label="Valor" v-bind="fiOptions">
              <a-textarea autoSize
                          v-decorator="['value', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Orden">
              <a-input-number
                style="width: 100%"
                v-decorator="['sort_order', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>

          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Activo" :has-feedback="false">
              <a-checkbox v-decorator="['active', {valuePropName: 'checked'}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        master: {
          endpoint: 'dynamic_load_param_item',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Etiqueta', dataIndex: 'label', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true},
              {title: 'Activo', dataIndex: 'active_desc', sorter: true},
              {title: 'Orden', dataIndex: 'sort_order', sorter: true}
            ],
            allowSelect: true,
            selectedRows: []
          },
          modalFieldsSetup: [
            {name: 'label'},
            {name: 'active', type: 'boolean'},
            {name: 'value'},
            {name: 'sort_order'}
          ]
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        }
      }
    },
    props: ['dynamic_load_param_id'],
    computed: {
      parenData () {
        return {dynamic_load_param_id: this.dynamic_load_param_id}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GDynamicLoads/DynamicLoadParamItem.vue